module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expertise-landing"
  }, [_c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }]
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.pageData.elements) ? _c('div', {
    staticClass: "text-center headline-container container-fluid"
  }, [(_vm.pageData.elements.page_title) ? _c('h1', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.pageData.elements.page_title.value))]) : _vm._e(), _vm._v(" "), (_vm.pageData.elements.page_intro) ? _c('p', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "intro_text"
  }, [_vm._v(_vm._s(_vm.pageData.elements.page_intro.value))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content-article"
  }, [_c('div', {
    staticClass: "inside"
  }, [(_vm.pageData.elements) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "content-article-body col-lg-9 col-sm-8 col-xs-12"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageData.elements.header_title.value))]), _vm._v(" "), (_vm.pageData.elements.vimeo_id.value.length) ? _c('div', {
    staticClass: "embed-container"
  }, [_c('iframe', {
    attrs: {
      "src": 'https://player.vimeo.com/video/' + _vm.pageData.elements.vimeo_id.value + '?loop=1&title=0&byline=0&portrait=0&api=1&muted=1&autoplay=1',
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "allow": "autoplay; fullscreen",
      "allowfullscreen": ""
    }
  })]) : (_vm.pageData.elements.thumbnail_image.value.length) ? _c('div', {
    staticClass: "mask-image"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.pageData.elements.thumbnail_image.value[0].url),
      expression: "pageData.elements.thumbnail_image.value[0].url"
    }],
    attrs: {
      "alt": _vm.pageData.elements.thumbnail_image.value[0].name
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.pageData.elements.main_content.value)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-article-author text-center right-column col-lg-3 col-sm-4 col-xs-12"
  }, [(_vm.pageData.elements.title.value.length != 0) ? _c('h4', [_vm._v(_vm._s(_vm.pageData.elements.title.value))]) : _vm._e(), _vm._v(" "), (_vm.pageData.elements.vimeo_id_right.value.length) ? _c('span', {
    staticClass: "resources_title"
  }, [_c('strong', [_vm._v("Video")])]) : _vm._e(), _vm._v(" "), (_vm.pageData.elements.vimeo_id_right.value.length) ? _c('div', {
    staticClass: "embed-container"
  }, [_c('iframe', {
    attrs: {
      "src": 'https://player.vimeo.com/video/' + _vm.pageData.elements.vimeo_id_right.value + '?loop=1&title=0&byline=0&portrait=0&api=1&muted=1&autoplay=1',
      "width": "640",
      "height": "360",
      "frameborder": "0",
      "allow": "autoplay; fullscreen",
      "allowfullscreen": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pageData.elements.resources.value.length > 0) ? _c('div', {
    staticClass: "related_content"
  }, [_c('ul', _vm._l((this.pageData.elements.resources.value), function(res) {
    return _c('li', [_c('a', {
      attrs: {
        "href": res.url,
        "title": res.name,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(res.name))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.relatedArticles.length > 0) ? _c('div', {
    staticClass: "related_content"
  }, [(_vm.pageData.elements.vimeo_id_right.value.length) ? _c('span', {
    staticClass: "resources_title"
  }, [_c('strong', [_vm._v("ARTICLES")])]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.relatedArticles), function(art) {
    return _c('li', [_c('a', {
      attrs: {
        "href": art.elements.url.value
      }
    }, [_vm._v(_vm._s(art.elements.header_title.value))])])
  }), 0)]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('contact', {
    attrs: {
      "labels": _vm.labels
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fd5b325","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Expertise.vue
// module id = 1502
// module chunks = 0